import styled from 'styled-components';
import { FaChevronDown } from 'react-icons/fa';

import theme from '../../../theme';

export const Group = styled.section`
  border: 1px solid ${theme.colors.grayish_blue};
  border-radius: 8px;
  overflow: hidden;

  & + & {
    margin-top: 12px;
  }
`;

export const GroupHeader = styled.div`
  display: flex;
  align-items: stretch;
`;

export const GroupToggle = styled.button`
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px 12px;
  min-width: 0;
  padding: 14px 16px;
  border: none;
  background: transparent;
  text-align: left;
  transition: background-color 0.2s ease;

  &:not(:disabled) {
    cursor: pointer;
  }

  &:not(:disabled):hover {
    background-color: ${theme.colors.light_gray};
  }

  &:disabled {
    cursor: default;
  }
`;

export const Summary = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
`;

export const ResendAction = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  padding-right: 16px;
`;

export const ResendLabel = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
`;

export const Chevron = styled(FaChevronDown)`
  color: ${theme.colors.medium_gray};
  transition: transform 0.3s ease;
  transform: rotate(${({ $open }) => ($open ? '180deg' : '0deg')});
`;

export const GroupBody = styled.div`
  padding: 0 16px 12px;
  border-top: 1px solid ${theme.colors.grayish_blue};
`;

export const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

export { IconWrapper } from '../styles';
